import Axios from 'axios'
import React from 'react'
import { FormEvent, FunctionComponent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

export const AddPayer: FunctionComponent = () => {
  const [disabled, setDisabled] = useState(false)
  const [name, setName] = useState('')
  const [inn, setInn] = useState('')

  const history = useHistory()

  const addPayer = async (_: FormEvent) => {
    _.preventDefault()

    setDisabled(true)

    try {
      const payer = await Axios.post<{ data: string }>(
        `${process.env.REACT_APP_API_URL}/api/v1/payers`,
        {
          name,
          inn,
        }
      )

      toast.success('Плательщик добавлен.')

      history.push(`/dashboard/edit-payer/${payer.data.data}`)
    } finally {
      setDisabled(false)
    }
  }

  return (
    <div className="row">
      <div className="col">
        <form onSubmit={addPayer}>
          <fieldset disabled={disabled}>
            <div className="form-group">
              <label>Название</label>
              <input
                className="form-control"
                required
                type="text"
                value={name}
                onChange={(_) => setName(_.target.value)}
              />
            </div>
            <div className="form-group">
              <label>ИНН</label>
              <input
                className="form-control"
                required
                type="text"
                value={inn}
                onChange={(_) => setInn(_.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-success">
              <i className="fas fa-save"></i> Сохранить
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  )
}
